<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="pa-2" outlined tile v-if="loading">
          <v-progress-linear  indeterminate color="blue"></v-progress-linear>
        </v-card>
        <v-card class="pa-2" outlined tile v-if="message">
          <v-alert type="error" class="cy-abacus-ticketing-update-error">
            {{ message }}
          </v-alert>
        </v-card>
        <v-card class="pa-2" outlined tile v-if="updateTaskResponse">
          <v-alert type="success" class="cy-abacus-ticketing-update-success">
            {{ $t('abacus.ticketing.update.success') }}
          </v-alert>
          <p><router-link :to="{ name: TICKETING_PROCESS_DETAILS, params: { processInstanceId: updateTaskResponse.ticket.ticketId}}">{{ $t('abacus.ticketing.common.openTicket') }}</router-link></p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TICKETING_PROCESS_DETAILS } from '@/config/options/routes/ticketingRoutes'
import { UPDATE_TASK } from '../graphql-apollo/abacusTicketing.gql.js'

export default {
  name: 'AbacusTicketingUpdate',
  data () {
    return {
      updateTaskResponse: null,
      message: '',
      loading: false,
      TICKETING_PROCESS_DETAILS: TICKETING_PROCESS_DETAILS
    }
  },
  created () {
    this.updateTask()
  },
  computed: {
    processDefinitionKey () {
      return this.$route.params.processDefinitionKey
    },
    externalTicketId () {
      return this.$route.params.externalTicketId
    },
    activityId () {
      return this.$route.params.activityId
    },
    name () {
      return this.$route.query.name
    },
    dueDate () {
      return this.$route.query.dueDate
    },
    candidateGroups () {
      if (this.$route.query.candidateGroups) {
        return this.$route.query.candidateGroups.split(',')
      } else {
        return []
      }
    }
  },
  methods: {
    updateTask () {
      this.message = null
      if (!this.processDefinitionKey) {
        this.message = this.$t('abacus.ticketing.common.missingInput') + 'processDefinitionKey'
      } else if (!this.externalTicketId) {
        this.message = this.$t('abacus.ticketing.common.missingInput') + 'externalTicketId'
      } else if (!this.activityId) {
        this.message = this.$t('abacus.ticketing.common.missingInput') + 'activityId'
      } else if (!this.name) {
        this.message = this.$t('abacus.ticketing.common.missingInput') + 'name'
      } else {
        this.updateTaskResponse = null
        this.loading = true
        this.$apollo.mutate({
          mutation: UPDATE_TASK,
          variables: {
            processDefinitionKey: this.processDefinitionKey,
            externalTicketId: this.externalTicketId,
            activityId: this.activityId,
            name: this.name,
            dueDate: this.dueDate,
            candidateGroups: this.candidateGroups
          }
        }).then((response) => {
          this.updateTaskResponse = response.data.updateTaskForExternalTicketId
          this.loading = false
        }).catch((error) => {
          if (error.toString().includes("TaskNotFoundException")) {
            this.message = this.$t('abacus.ticketing.common.taskNotFoundException')
          } else if (error.toString().includes("TicketNotFoundException")) {
            this.message = this.$t('abacus.ticketing.common.ticketNotFoundException')
          } else {
            this.message = this.message = this.$t('abacus.ticketing.update.failure') + error
          }
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped lang="postcss">
</style>
